import Label from "../Label";
import Input from "../Input";

const FormInputField = ({
  label,
  name,
  id,
  type,
  placeholder,
  icon,
  value,
  onChange,
  readOnly,
  currency,
  isDisabled,
  maxLength,
  required,
  error,
}) => {
  return (
    <div className="flex flex-col w-full">
      <div
        className={`w-full px-3 py-2 relative rounded-xl  shadow-sm ${
          readOnly
            ? "form-input-field-wrapper-readonly cursor-pointer"
            : error
            ? "form-input-field-wrapper-error"
            : "form-input-field-wrapper-default"
        }`}
      >
        <Label
          htmlFor={id}
          className={`block text-xs font-medium ${
            isDisabled ? "form-input-field-disabled-lable" : "form-input-field-lable"
          }`}
          text={label}
        />
        <div className="flex items-center space-x-1">
          {currency && (
            <span className="text-sm form-input-field-currency">{currency}</span>
          )}
          <Input
            type={type}
            name={name}
            id={id}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            min="1"
            className={`block no-arrows autofill-input w-full bg-transparent border-0 p-0 text-sm font-medium form-input-field-input placeholder:font-normal focus:ring-0`}
            isDisabled={isDisabled}
            readOnly={readOnly}
            maxLength={maxLength}
            required={required}
          />
          {icon && (
            <div className="absolute inset-y-0 right-0 flex items-center pr-3 hover:cursor-pointer">
              {icon}
            </div>
          )}
        </div>
      </div>
      {error && <span className="text-error-500 text-sm pl-1 pt-0.5">{error}</span>}
    </div>
  );
};

export default FormInputField;
